import { Draggable } from "@hello-pangea/dnd";
import { RecordContextProvider, useRedirect } from "ra-core";
import { Badge } from "@/components/ui/badge";
import { Card, CardContent } from "@/components/ui/card";

import { tierColor, tierLetter } from "../dealsmap/leadUtils";
import type { Prospect } from "../types";
import { primaryPhone } from "./prospectModel";

export const ProspectCard = ({
  prospect,
  index,
}: {
  prospect: Prospect;
  index: number;
}) => {
  if (!prospect) return null;

  return (
    <Draggable draggableId={String(prospect.id)} index={index}>
      {(provided, snapshot) => (
        <ProspectCardContent
          provided={provided}
          snapshot={snapshot}
          prospect={prospect}
        />
      )}
    </Draggable>
  );
};

const ProspectCardContent = ({
  provided,
  snapshot,
  prospect,
}: {
  provided?: any;
  snapshot?: any;
  prospect: Prospect;
}) => {
  const redirect = useRedirect();
  const handleClick = () => {
    redirect(`/prospects/${prospect.id}/show`, undefined, undefined, undefined, {
      _scrollToTop: false,
    });
  };

  const phone = primaryPhone(prospect);

  return (
    <div
      className="cursor-pointer"
      {...provided?.draggableProps}
      {...provided?.dragHandleProps}
      ref={provided?.innerRef}
      onClick={handleClick}
    >
      <RecordContextProvider value={prospect}>
        <Card
          className={`py-3 transition-all duration-200 ${
            snapshot?.isDragging
              ? "opacity-90 rotate-1 shadow-lg"
              : "shadow-sm hover:shadow-md"
          }`}
        >
          <CardContent className="px-3 flex flex-col gap-1">
            <div className="flex items-start justify-between gap-2">
              <p className="text-sm font-medium">{prospect.owner_name}</p>
              {tierLetter(prospect.deal_tier) ? (
                <Badge
                  className="text-white border-transparent shrink-0"
                  title={prospect.deal_tier ?? undefined}
                  style={{ backgroundColor: tierColor(prospect.deal_tier) }}
                >
                  {tierLetter(prospect.deal_tier)}
                </Badge>
              ) : null}
            </div>
            {prospect.property_address ? (
              <p className="text-xs text-muted-foreground truncate">
                {prospect.property_address}
              </p>
            ) : null}
            <div className="flex justify-between text-xs text-muted-foreground">
              <span>{phone ?? ""}</span>
              {prospect.auction_date ? (
                <span title="Auction date">{prospect.auction_date}</span>
              ) : null}
            </div>
          </CardContent>
        </Card>
      </RecordContextProvider>
    </div>
  );
};
